

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const NEWSLETTERPOST= createAsyncThunk(
  "NewsletterPost/NewsletterPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const NewsletterPostSlice = createSlice({
  name: "NewsletterPostSlice",
  initialState: {
    NewsletterPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfNewsletterPost: (state) => {
        state.NewsletterPost.loading = false
        state.NewsletterPost.error = false
        state.NewsletterPost.data = []
        state.NewsletterPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(NEWSLETTERPOST.fulfilled, (state, action) => {
      state.NewsletterPost = {
        ...state.NewsletterPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(NEWSLETTERPOST.pending, (state, action) => {
      state.NewsletterPost = {
        ...state.NewsletterPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(NEWSLETTERPOST.rejected, (state, action) => {
      state.NewsletterPost = {
        ...state.NewsletterPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const NewsletterPostAction = {
    NEWSLETTERPOST,
};

export { NewsletterPostAction };
export default NewsletterPostSlice.reducer;
export const {setInitialStateOfNewsletterPost} = NewsletterPostSlice.actions
